module.exports = require('./helpers/bundle-url').getBundleURL('lQbzt') + "logo-dark.eefe0b7f.svg";